// eventBusPlugin.js
import Vue from 'vue';
const Bus = new Vue();

export default ({ app }, inject) => {
  inject('Bus', Bus);
};